import { getStateWithOnlyOneLevel } from '../../../utils/StateSelectorHelper';

function getNotificationPreferencesState(state) {
  return getStateWithOnlyOneLevel(state, 'notificationPreferences');
}

export function getPreferences(state) {
  return getNotificationPreferencesState(state).get('preferences');
}

export function getIsLoadingPreferences(state) {
  return getNotificationPreferencesState(state).get('isLoadingPreferences');
}

export function getIsLoadingCustomerSite(state) {
  return getNotificationPreferencesState(state).get('isLoadingCustomerSite');
}
